// extracted by mini-css-extract-plugin
module.exports = {"animated":"Progressbar_animated__sdvjJ"};